import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import axios from "axios";

type SliderData = {
  title: string;
  content: string;
  image: string;
};

const Sliders = () => {
  const [activeSliderIndex, setActiveSliderIndex] = useState(0); // Store active slider index
  const [sliders, setSliders] = useState<SliderData[]>([]); // Array of sliders


  const [formData, setFormData] = useState({ title: "" });

  // Fetch data from API
  useEffect(() => {
    const fetchNewsHeadingData = async () => {
      try {
        const response = await axios.get("https://rmbbackend.rmbjaipur.com/auth/newsheading");
        console.log("Fetched news heading data:", response.data);
        
        if (response.data && response.data.data && response.data.data.length > 0) {

          setFormData({ title: response.data.data[0].title });
        }
      } catch (error) {
        console.error("Failed to fetch news heading:", error);
      }
    };

    fetchNewsHeadingData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<SliderData[]>("https://rmbbackend.rmbjaipur.com/auth/homeslider");
        console.log("Fetched slider data:", response.data);

        // Transform slider images to correct URL format
        const transformedSliders = response.data.map((slider) => ({
          ...slider,
          image: `url(https://rmbbackend.rmbjaipur.com/${slider.image.replace(/\\/g, '/')})`,
        }));

        setSliders(transformedSliders);
      } catch (error) {
        console.error("Slider data fetch failed:", error);
      }
    };

    fetchData();
  }, []);

  const handlePrevious = () => {
    setActiveSliderIndex((prevIndex) => (prevIndex === 0 ? sliders.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setActiveSliderIndex((prevIndex) => (prevIndex + 1) % sliders.length);
  };

  if (sliders.length === 0) {
    return null;
  }

  return (
    <div className="h-[620px]">

      {/* Main Slider Section */}
      {sliders.length > 0 && (
        <div
          className="main-container relative w-full h-[620px] p-0 bg-blend-darken"
          style={{
            backgroundImage: sliders[activeSliderIndex].image,
            backgroundPosition: "top center",
            backgroundSize: "cover",
          }}
        >
          {/* Slider Content */}
          <div className="flex flex-col justify-center items-center h-full text-center z-30">
            <h1 className="z-30 lg:text-[61px] text-[34px] text-white lg:mt-48">
              {sliders[activeSliderIndex].title}
            </h1>
            <p className="z-30 text-[20px] w-[80%] text-center text-[#CBD5E0]">
              {sliders[activeSliderIndex].content}
            </p>

            {/* Pagination Dots */}
            <div className="flex justify-center space-x-4 mt-4 z-10 absolute bottom-2">
              {sliders.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveSliderIndex(index)}
                  className={`w-4 h-4 border border-[#64748B] rounded-full ${
                    activeSliderIndex === index
                      ? "bg-[#FDBC12] border-yellow-400"
                      : ""
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="absolute lg:left-24 left-4 top-1/2 transform -translate-y-1/2 z-40 bg-black/25 w-[40px] h-[40px] flex justify-center items-center rounded">
            <button onClick={handlePrevious} className="text-white text-3xl">
              <RiArrowLeftSLine />
            </button>
          </div>
          <div className="absolute lg:right-24 right-4 top-1/2 transform -translate-y-1/2 z-40 bg-black/25 w-[40px] h-[40px] flex justify-center items-center rounded">
            <button onClick={handleNext} className="text-white text-3xl">
              <RiArrowRightSLine />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sliders;
